/**
 * Promise polyfill.
 *
 * @see https://github.com/taylorhakes/promise-polyfill
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (factory());
}(this, (function () {
    'use strict';

    /**
     * @this {Promise}
     */
    function finallyConstructor(callback)
    {
        var constructor = this.constructor;
        return this.then(
            function (value) {
                // @ts-ignore
                return constructor.resolve(callback()).then(function () {
                    return value;
                });
            },
            function (reason) {
                // @ts-ignore
                return constructor.resolve(callback()).then(function () {
                    // @ts-ignore
                    return constructor.reject(reason);
                });
            }
        );
    }

    function allSettled(arr)
    {
        var P = this;
        return new P(function (resolve, reject) {
            if (!(arr && typeof arr.length !== 'undefined')) {
                return reject(
                    new TypeError(
                        typeof arr +
                        ' ' +
                        arr +
                        ' is not iterable(cannot read property Symbol(Symbol.iterator))'
                    )
                );
            }
            var args = Array.prototype.slice.call(arr);
            if (args.length === 0) return resolve([]);
            var remaining = args.length;

            function res(i, val)
            {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(
                            val,
                            function (val) {
                                res(i, val);
                            },
                            function (e) {
                                args[i] = {status: 'rejected', reason: e};
                                if (--remaining === 0) {
                                    resolve(args);
                                }
                            }
                        );
                        return;
                    }
                }
                args[i] = {status: 'fulfilled', value: val};
                if (--remaining === 0) {
                    resolve(args);
                }
            }

            for (var i = 0; i < args.length; i++) {
                res(i, args[i]);
            }
        });
    }

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
    var setTimeoutFunc = setTimeout;

    function isArray(x)
    {
        return Boolean(x && typeof x.length !== 'undefined');
    }

    function noop()
    {
    }

// Polyfill for Function.prototype.bind
    function bind(fn, thisArg)
    {
        return function () {
            fn.apply(thisArg, arguments);
        };
    }

    /**
     * @constructor
     * @param {Function} fn
     */
    function Promise(fn)
    {
        if (!(this instanceof Promise))
            throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        /** @type {!number} */
        this._state = 0;
        /** @type {!boolean} */
        this._handled = false;
        /** @type {Promise|undefined} */
        this._value = undefined;
        /** @type {!Array<!Function>} */
        this._deferreds = [];

        doResolve(fn, this);
    }

    function handle(self, deferred)
    {
        while (self._state === 3) {
            self = self._value;
        }
        if (self._state === 0) {
            self._deferreds.push(deferred);
            return;
        }
        self._handled = true;
        Promise._immediateFn(function () {
            var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
            if (cb === null) {
                (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                return;
            }
            var ret;
            try {
                ret = cb(self._value);
            } catch (e) {
                reject(deferred.promise, e);
                return;
            }
            resolve(deferred.promise, ret);
        });
    }

    function resolve(self, newValue)
    {
        try {
            // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
            if (newValue === self)
                throw new TypeError('A promise cannot be resolved with itself.');
            if (
                newValue &&
                (typeof newValue === 'object' || typeof newValue === 'function')
            ) {
                var then = newValue.then;
                if (newValue instanceof Promise) {
                    self._state = 3;
                    self._value = newValue;
                    finale(self);
                    return;
                } else if (typeof then === 'function') {
                    doResolve(bind(then, newValue), self);
                    return;
                }
            }
            self._state = 1;
            self._value = newValue;
            finale(self);
        } catch (e) {
            reject(self, e);
        }
    }

    function reject(self, newValue)
    {
        self._state = 2;
        self._value = newValue;
        finale(self);
    }

    function finale(self)
    {
        if (self._state === 2 && self._deferreds.length === 0) {
            Promise._immediateFn(function () {
                if (!self._handled) {
                    Promise._unhandledRejectionFn(self._value);
                }
            });
        }

        for (var i = 0, len = self._deferreds.length; i < len; i++) {
            handle(self, self._deferreds[i]);
        }
        self._deferreds = null;
    }

    /**
     * @constructor
     */
    function Handler(onFulfilled, onRejected, promise)
    {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.promise = promise;
    }

    /**
     * Take a potentially misbehaving resolver function and make sure
     * onFulfilled and onRejected are only called once.
     *
     * Makes no guarantees about asynchrony.
     */
    function doResolve(fn, self)
    {
        var done = false;
        try {
            fn(
                function (value) {
                    if (done) return;
                    done = true;
                    resolve(self, value);
                },
                function (reason) {
                    if (done) return;
                    done = true;
                    reject(self, reason);
                }
            );
        } catch (ex) {
            if (done) return;
            done = true;
            reject(self, ex);
        }
    }

    Promise.prototype['catch'] = function (onRejected) {
        return this.then(null, onRejected);
    };

    Promise.prototype.then = function (onFulfilled, onRejected) {
        // @ts-ignore
        var prom = new this.constructor(noop);

        handle(this, new Handler(onFulfilled, onRejected, prom));
        return prom;
    };

    Promise.prototype['finally'] = finallyConstructor;

    Promise.all = function (arr) {
        return new Promise(function (resolve, reject) {
            if (!isArray(arr)) {
                return reject(new TypeError('Promise.all accepts an array'));
            }

            var args = Array.prototype.slice.call(arr);
            if (args.length === 0) return resolve([]);
            var remaining = args.length;

            function res(i, val)
            {
                try {
                    if (val && (typeof val === 'object' || typeof val === 'function')) {
                        var then = val.then;
                        if (typeof then === 'function') {
                            then.call(
                                val,
                                function (val) {
                                    res(i, val);
                                },
                                reject
                            );
                            return;
                        }
                    }
                    args[i] = val;
                    if (--remaining === 0) {
                        resolve(args);
                    }
                } catch (ex) {
                    reject(ex);
                }
            }

            for (var i = 0; i < args.length; i++) {
                res(i, args[i]);
            }
        });
    };

    Promise.allSettled = allSettled;

    Promise.resolve = function (value) {
        if (value && typeof value === 'object' && value.constructor === Promise) {
            return value;
        }

        return new Promise(function (resolve) {
            resolve(value);
        });
    };

    Promise.reject = function (value) {
        return new Promise(function (resolve, reject) {
            reject(value);
        });
    };

    Promise.race = function (arr) {
        return new Promise(function (resolve, reject) {
            if (!isArray(arr)) {
                return reject(new TypeError('Promise.race accepts an array'));
            }

            for (var i = 0, len = arr.length; i < len; i++) {
                Promise.resolve(arr[i]).then(resolve, reject);
            }
        });
    };

// Use polyfill for setImmediate for performance gains
    Promise._immediateFn =
        // @ts-ignore
        (typeof setImmediate === 'function' &&
            function (fn) {
                // @ts-ignore
                setImmediate(fn);
            }) ||
        function (fn) {
            setTimeoutFunc(fn, 0);
        };

    Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
        if (typeof console !== 'undefined' && console) {
            console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
        }
    };

    /** @suppress {undefinedVars} */
    var globalNS = (function () {
        // the only reliable means to get the global object is
        // `Function('return this')()`
        // However, this causes CSP violations in Chrome apps.
        if (typeof self !== 'undefined') {
            return self;
        }
        if (typeof window !== 'undefined') {
            return window;
        }
        if (typeof global !== 'undefined') {
            return global;
        }
        throw new Error('unable to locate global object');
    })();

// Expose the polyfill if Promise is undefined or set to a
// non-function value. The latter can be due to a named HTMLElement
// being exposed by browsers for legacy reasons.
// https://github.com/taylorhakes/promise-polyfill/issues/114
    if (typeof globalNS['Promise'] !== 'function') {
        globalNS['Promise'] = Promise;
    } else if (!globalNS.Promise.prototype['finally']) {
        globalNS.Promise.prototype['finally'] = finallyConstructor;
    } else if (!globalNS.Promise.allSettled) {
        globalNS.Promise.allSettled = allSettled;
    }

})));

/**
 * Array.from Polyfill
 * Production steps of ECMA-262, Edition 6, 22.1.2.1
 *
 * https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/from
 */
if (!Array.from) {
    Array.from = (function () {
        let toStr = Object.prototype.toString;
        let isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };

        let toInteger = function (value) {
            let number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };

        let maxSafeInteger = Math.pow(2, 53) - 1;
        let toLength = function (value) {
            let len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */) {
            // 1. Let C be the this value.
            let C = this;

            // 2. Let items be ToObject(arrayLike).
            let items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }

            // 4. If mapfn is undefined, then let mapping be false.
            let mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            let T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            let len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method
            // of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            let A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            let k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            let kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

/**
 * Date.now Polyfill
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now
 */
if (Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

/**
 * Element.matches() Polyfill IE 9+
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/**
 * Element.closest() Polyfill IE 9+
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        let el = this;
        do {
            if (el.matches(s)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);

        return null;
    };
}

/**
 * ChildNode.remove() Polyfill IE 9+
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
 */
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null)
                    this.parentNode.removeChild(this);
            }
        });
    });
})
([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/**
 * Object.create() Polyfill
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
 */
if (typeof Object.create !== 'function') {
    Object.create = function (proto, propertiesObject) {
        if (typeof proto !== 'object' && typeof proto !== 'function') {
            throw new TypeError('Object prototype may only be an Object: ' + proto);
        } else if (proto === null) {
            throw new Error("This browser's implementation of Object.create is a shim and doesn't support 'null' as the first argument.");
        }

        if (typeof propertiesObject != 'undefined') {
            throw new Error("This browser's implementation of Object.create is a shim and doesn't support a second argument.");
        }

        function F()
        {
        }

        F.prototype = proto;

        return new F();
    };
}

/**
 * Element.prototype.classList for IE8/9, Safari.
 * @author    Kerem Güneş <k-gun@mail.com>
 * @copyright Released under the MIT License <https://opensource.org/licenses/MIT>
 * @version   1.2
 * @see       https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
 * Source: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca
 */
(function () {
    // Helpers.
    let trim = function (s) {
            return s.replace(/^\s+|\s+$/g, '');
        },
        regExp = function (name) {
            return new RegExp('(^|\\s+)' + name + '(\\s+|$)');
        },
        forEach = function (list, fn, scope) {
            for (let i = 0; i < list.length; i++) {
                fn.call(scope, list[i]);
            }
        };

    // Class list object with basic methods.
    function ClassList(element)
    {
        this.element = element;
    }

    ClassList.prototype = {
        add: function () {
            forEach(arguments, function (name) {
                if (!this.contains(name)) {
                    this.element.className = trim(this.element.className + ' ' + name);
                }
            }, this);
        },
        remove: function () {
            forEach(arguments, function (name) {
                this.element.className = trim(this.element.className.replace(regExp(name), ' '));
            }, this);
        },
        toggle: function (name) {
            return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
        },
        contains: function (name) {
            return regExp(name).test(this.element.className);
        },
        item: function (i) {
            return this.element.className.split(/\s+/)[i] || null;
        },
        replace: function (oldName, newName) {
            this.remove(oldName);
            this.add(newName);
        }
    };

    // IE8/9, Safari
    // Remove this if statements to override native classList.
    if (!('classList' in Element.prototype)) {
        // Use this if statement to override native classList that does not have for example replace() method.
        // See browser compatibility: https://developer.mozilla.org/en-US/docs/Web/API/Element/classList#Browser_compatibility.
        // if (!('classList' in Element.prototype) ||
        //     !('classList' in Element.prototype && Element.prototype.classList.replace)) {
        Object.defineProperty(Element.prototype, 'classList', {
            get: function () {
                return new ClassList(this);
            }
        });
    }

    // For others replace() support.
    if (window.DOMTokenList && !DOMTokenList.prototype.replace) {
        DOMTokenList.prototype.replace = ClassList.prototype.replace;
    }
})();

/**
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 *
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 *
 * MIT license
 */
(function () {
    let lastTime = 0;
    let vendors = ['ms', 'moz', 'webkit', 'o'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            let currTime = Date.now();
            let timeToCall = Math.max(0, 16 - (currTime - lastTime));
            let id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());

(function (
    global,
    undefined
) {
    class ModuleRegistrar
    {
        /**
         * All registered modules.
         *
         * @type {{Module}}
         */
        modules = {};

        /**
         * Registers a module.
         *
         * @param {Module} module
         */
        register(module)
        {
            let moduleName = module.getName();

            if (! this.modules.hasOwnProperty(moduleName) || undefined === this.modules[moduleName]) {
                this.modules[moduleName] = module;
            }
        }

        /**
         * Retrieves the given module.
         *
         * @param {string} moduleName
         * @returns {Module|null}
         */
        getModule(moduleName)
        {
            if (! this.modules.hasOwnProperty(moduleName) || undefined === this.modules[moduleName]) {
                console.log('There is no module registered with name "' + moduleName + '"');
                return null;
            }

            return this.modules[moduleName];
        }

        /**
         * Instantiates the given module.
         *
         * @param {string} moduleName
         * @returns {boolean}
         */
        instantiate(moduleName)
        {
            if (! this.modules.hasOwnProperty(moduleName) || undefined === this.modules[moduleName]) {
                console.log('There is no module registered with name "' + moduleName + '"');
                return false;
            }

            this.modules[moduleName].instantiate();
            return true;
        }

        /**
         * Retrieves the instance of the given module.
         *
         * @param {string} moduleName
         * @returns {Object}
         */
        getInstance(moduleName)
        {
            return this.modules[moduleName].getInstance();
        }
    }

    if (! global.hasOwnProperty('webSCAPE') || undefined === global.webSCAPE) {
        global.webSCAPE = {};
    }

    global.webSCAPE.moduleRegistrar = new ModuleRegistrar();
})(
    window
);

(function (
    global,
    $,
    undefined
) {
    class Module
    {
        /**
         * Instantiated module class.
         *
         * @type {Class|Object|null}
         */
        instance = null;

        /**
         * Instances created by module selector.
         *
         * @type {Array}
         */
        instances = [];

        /**
         * @param {string} name
         * @param {Object} moduleClass
         * @param {string|null} selector
         */
        constructor(name, moduleClass, selector = null)
        {
            this.name = name;
            this.moduleClass = moduleClass;
            this.selector = selector;

            if (null !== this.selector) {
                $(document).ready(() => {
                    if (! $(this.selector).length) {
                        return;
                    }

                    $(this.selector).each((index, item) => {
                        this.instances.push(new this.moduleClass(item));
                    });
                });
            }
        }

        /**
         * Retrieves the module name.
         *
         * @return {string}
         */
        getName()
        {
            return this.name;
        }

        /**
         * Retrieves the module class.
         *
         * @return {Object}
         */
        getClass()
        {
            return this.moduleClass;
        }

        /**
         * Instantiates the module.
         *
         * @param args
         */
        instantiate(...args)
        {
            this.instance = new this.moduleClass(...args);
        }

        /**
         * Retrieves the module instance.
         *
         * @param args
         * @return {Class|Object|null}
         */
        getInstance(...args)
        {
            if (null === this.instance) {
                this.instantiate(args);
            }

            return this.instance;
        }
    }

    if (! global.hasOwnProperty('webSCAPE') || undefined === global.webSCAPE) {
        global.webSCAPE = {};
    }

    global.webSCAPE.Module = Module;
})(
    window,
    jQuery
);

(function (
    global,
    moduleRegistrar,
    Module,
    undefined
) {
    class Cookie
    {
        /**
         * Sets a cookie with the given name.
         *
         * @param {string} name
         * @param {mixed}  value
         * @param {number} days
         */
        set(name, value, days)
        {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            let expires = 'expires=' + date.toUTCString();

            document.cookie = name + '=' + value + ';' + expires + ';path=/';
        }

        /**
         * Retrieves a cookie by the given name.
         *
         * @param {string} name
         */
        get(name)
        {
            name += '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookies = decodedCookie.split(';');

            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];

                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1);
                }

                if (cookie.indexOf(name) === 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }

            return '';
        }

        /**
         * Deletes a cookie by the given name.
         *
         * @param {string} name
         */
        delete(name)
        {
            this.set(name, null, -30);
        }
    }

    moduleRegistrar.register(new Module('webscape-cookie', Cookie));
    moduleRegistrar.instantiate('webscape-cookie');
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    moduleRegistrar,
    Module,
    undefined
) {
    class LocalStorage
    {
        /**
         * Sets an item in the local storage.
         *
         * @param {string} key
         * @param {mixed} value
         */
        set(key, value)
        {
            global.localStorage.setItem(key, JSON.stringify(value));
        }

        /**
         * Retrieves an item from the local storage.
         *
         * @param {string} key
         * @return {mixed}
         */
        get(key)
        {
            return JSON.parse(global.localStorage.getItem(key));
        }

        /**
         * Removes an item from the local storage.
         *
         * @param {string} key
         */
        remove(key)
        {
            global.localStorage.removeItem(key);
        }

        /**
         * Clears all items from the local storage.
         */
        clear()
        {
            global.localStorage.clear();
        }
    }

    moduleRegistrar.register(new Module('webscape-local-storage', LocalStorage));
    moduleRegistrar.instantiate('webscape-local-storage');
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    browserWindow,
    domDocument,
    moduleRegistrar,
    Module,
    undefined
) {
    class Window
    {
        /**
         * Retrieves window y scroll position in pixel.
         *
         * @returns {number}
         */
        scrollTop()
        {
            return Math.max(
                browserWindow.pageYOffset,
                domDocument.documentElement.scrollTop,
                domDocument.body.scrollTop
            );
        }

        /**
         * Retrieves window width in pixel.
         *
         * @returns {number}
         */
        width()
        {
            return isNaN(browserWindow.innerWidth)
                ? browserWindow.clientWidth
                : browserWindow.innerWidth;
        }

        /**
         * Retrieves window height in pixel.
         *
         * @returns {number}
         */
        height()
        {
            return isNaN(browserWindow.innerHeight)
                ? browserWindow.clientHeight
                : browserWindow.innerHeight;
        }
    }

    moduleRegistrar.register(new Module('webscape-window', Window));
    moduleRegistrar.instantiate('webscape-window');
})(
    window,
    document,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    moduleRegistrar,
    Module,
    undefined
) {
    class ObjectHelper
    {
        /*!
         * Add items to an object at a specific path
         * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
         * @param  {Object}       obj  The object
         * @param  {String|Array} path The path to assign the value to
         * @param  {*}            val  The value to assign
         */
        set(obj, path, val)
        {
            // Convert the path to an array if not already
            let keys = this.pathToKeys(path);
    
            // Cache the keys length and current spot in the object
            let length = keys.length;
            let current = obj;
    
            // Loop through the keys
            keys.forEach(function (key, index) {
                // Check if the assigned key should be an array
                let isArray = key.slice(-2) === '[]';
    
                // If so, get the true key name by removing the trailing []
                key = isArray ? key.slice(0, -2) : key;
    
                // If the key should be an array and isn't, create an array
                if (isArray && !Array.isArray(current[key])) {
                    current[key] = [];
                }
    
                // If this is the last item in the loop, assign the value
                if (index === length -1) {
                    // If it's an array, push the value
                    // Otherwise, assign it
                    if (isArray) {
                        current[key].push(val);
                    } else {
                        current[key] = val;
                    }
                // Otherwise, update the current place in the object
                } else {
                    // If the key doesn't exist, create it
                    if (!current[key]) {
                        current[key] = {};
                    }
    
                    // Update the current place in the object
                    current = current[key];
                }
            });
        }

        get(obj, path)
        {
            let value = obj;
            let keys = this.pathToKeys(path);

            keys.forEach(key => {
                if (typeof value === 'object' && value.hasOwnProperty(key)) {
                    value = value[key];
                }
            });

            return value;
        }

        /**
         * If the path is a string, convert it to an array
         * @param  {String|Array} path The path
         * @return {Array}             The path array
         */
        pathToKeys (path)
        {
            // If the path isn't a string, return it
            if (typeof path !== 'string') return path;

            // Create new array
            let output = [];

            // Split to an array with dot notation
            path.split('.').forEach(function (item) {
                // Split to an array with bracket notation
                item.split(/\[([^}]+)\]/g).forEach(function (key) {
                    // Push to the new array
                    if (key.length > 0) {
                        output.push(key);
                    }
                });
            });

            return output;
        }
    }

    moduleRegistrar.register(new Module('webscape-object-helper', ObjectHelper));
    moduleRegistrar.instantiate('webscape-object-helper');
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    moduleRegistrar,
    Module,
    undefined
) {
    class Throttle
    {
        /**
         * @param   {function(): *} func
         * @param   {number} waitTime
         * @param   {Object} options
         * @returns {function(): *}
         */
        constructor(func, waitTime, options = {})
        {
            this.function = func;
            this.waitTime = waitTime;
            this.options = options;
            this.timeout = null;
            this.context = null;
            this.args = null;
            this.result = null;
            this.previous = 0;

            let self = this;

            return function () {
                let now = Date.now();

                if (! self.previous && false === self.options.leading) {
                    self.previous = now;
                }

                let remaining = self.waitTime - (now - self.previous);
                self.context = this;
                self.args = arguments;

                if (remaining <= 0 || remaining > self.waitTime) {
                    if (self.timeout) {
                        clearTimeout(self.timeout);
                        self.timeout = null;
                    }

                    self.previous = now;
                    self.result = self.function.apply(self.context, self.args);

                    if (! self.timeout) {
                        self.context = self.args = null;
                    }

                } else if (! self.timeout && self.options.trailing !== false) {
                    self.timeout = setTimeout(self.later, remaining);
                }

                return self.result;
            }
        }

        later()
        {
            this.previous = this.options.leading === false ? 0 : Date.now();
            this.timeout = null;
            this.result = this.function.apply(this.context, this.args);

            if (! this.timeout) {
                this.context = this.args = null;
            }
        }
    }

    moduleRegistrar.register(new Module('webscape-throttle', Throttle));
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    moduleRegistrar,
    Module,
    $,
    undefined
) {
    class Ajax
    {
        /**
         * Request method.
         *
         * @type {string}
         */
        method = 'POST';

        /**
         * AJAX URL.
         *
         * @type {string}
         */
        url = '';

        /**
         * AJAX data.
         *
         * @type {Object|Array|string}
         */
        data = {};

        /**
         * Pre-request callback function.
         *
         * @param {jqXHR} xhr
         */
        beforeSend(xhr)
        {
        }

        /**
         * Called when the request finished (after success and error callbacks are executed).
         *
         * @param {jqXHR} xhr
         * @param {string} status
         */
        complete(xhr, status)
        {
        }

        /**
         * Called if the request has succeeded.
         *
         * @param {jqXHR} xhr
         * @param {String} status
         */
        success(xhr, status)
        {
        }

        /**
         * Called if the request has failed.
         *
         * @param {jqXHR}  xhr
         * @param {string} status
         * @param {string} error
         */
        error(xhr, status, error)
        {
        }

        /**
         * Executes the AJAX request.
         */
        execute()
        {
            return $.ajax(
                this.url,
                {
                    method: this.method,
                    data: this.data,
                    beforeSend: this.beforeSend,
                    complete: this.complete,
                    success: this.success,
                    error: this.error,
                }
            );
        }
    }

    moduleRegistrar.register(new Module('webscape-ajax', Ajax));
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    jQuery
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    Ajax,
    undefined
) {
    class PartialsAjaxController extends Ajax
    {
        /**
         * @inheritDoc
         */
        url = wp_ajax.url;

        /**
         * @inheritDoc
         */
        data = {
            action: 'webscape_partials',
            fields: {},
        };

        /**
         * Called if the request succeeds.
         *
         * @param {jqXHR} result
         * @param {String} status
         */
        success(result, status)
        {
            if (result.error) {
                console.log(result.error);
                return;
            }

            result = JSON.parse(result);

            Object.keys(result).forEach((selector, index) => {
                $('[data-partial="' + selector + '"]').replaceWith(result[selector]);
            });

            $(document).trigger('webscapa_partials_ajax:success');
        }
    }

    moduleRegistrar.register(new Module('webscape-partials-ajax', PartialsAjaxController));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-ajax').getClass()
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    Ajax,
    undefined
) {
    class FormAjaxController extends Ajax
    {
        /**
         * @inheritDoc
         */
        url = wp_ajax.url;

        /**
         * @inheritDoc
         */
        data = {
            action: 'webscape_form_ajax',
            form: {
                fields: {},
            },
        };

        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            form: '[data-js="form"][data-ajax="true"]',
            formSubmit: 'button[type="submit"]',
            formInputs: 'input, select, textarea',
        };

        constructor()
        {
            super();
            this.init();
        }

        init()
        {
            console.log('init form');
            let fieldName = '';
            let fieldValue = '';

            $(this.selectors.form).find(this.selectors.formSubmit).on('click', (e) => {
                e.preventDefault();

                $(this.selectors.form).find(this.selectors.formInputs).each((index, input) => {
                    fieldName = $(input).attr('name');
                    fieldValue = $(input).val();
                    this.data.form.fields[fieldName] = fieldValue;
                });

                console.log(this.data);

                this.execute();
            });
        }

        /**
         * Called if the request succeeds.
         *
         * @param {jqXHR} result
         * @param {String} status
         */
        success(result, status)
        {
            if (result.error) {
                console.log(result.error);
                return;
            }

            console.log('JSON', result);
        }
    }

    moduleRegistrar.register(new Module('webscape-form-ajax', FormAjaxController, '[data-js="form"][data-ajax="true"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-ajax').getClass()
);

(function (
	global,
	$,
	moduleRegistrar,
	Module,
	undefined
) {
	class ContextualForm
	{
		/**
		 * JavaScript selectors.
		 *
		 * @type {object}
		 */
		selectors = {
			contextualElement: '[data-contextual]',
		};

		/**
		 * Fields with it's contextual relations.
		 *
		 * @type {object}
		 */
		dependingFields = {};

		constructor()
		{
			if ($(this.selectors.contextualElement).length) {
				this.init();
			}

			$(document).on('form:contextual:init', () => {
				this.init();
			});
		}

		init()
		{
			$(this.selectors.contextualElement).each((index, element) => {
				this.applyContext($(element), JSON.parse($(element).attr('data-contextual')));
			});

			let inputTimeout = null;

			for (let field in this.dependingFields) {
				$(document.getElementById(field)).on('input', e => {
					clearTimeout(inputTimeout);
					inputTimeout = setTimeout(() => {
						this.dependingFields[field].forEach(id => {
							let input = $(document.getElementById(id));
							this.applyContext(input, JSON.parse(input.attr('data-contextual')));
						});
					}, 250);
				});
			}
		}

		/**
		 * Apply context of field.
		 *
		 * @param 	{jQuery} el
		 * @param 	{object} context
		 * @returns {void}
		 */
		applyContext(el, context)
		{
			let showField = false;
			let relation = 'or';
			let conditions = [];

			if (context.hasOwnProperty('relation')) {
				relation = context.relation;
			}

			if (context.hasOwnProperty('conditions')) {
				conditions = context.conditions;
			}

			let falseResults = 0;
			let trueResults = 0;

			for (let i = 0; i < conditions.length; i++) {
				if (!conditions[i].hasOwnProperty('field') || !conditions[i].hasOwnProperty('value')) {
					return;
				}

				let field = conditions[i].field;
				let value = conditions[i].value;
				let type = 'default';
				let compare = '=';

				if (!this.dependingFields.hasOwnProperty(field)) {
					this.dependingFields[field] = [];
				}

				if (!this.dependingFields[field].includes(el.attr('id'))) {
					this.dependingFields[field].push(el.attr('id'));
				}

				if (conditions[i].hasOwnProperty('compare')) {
					compare = conditions[i].compare;
				}

				let fieldEl = $(document.getElementById(field));
				let fieldValue;

				if (fieldEl.attr('type') === 'checkbox' || fieldEl.attr('type') === 'radio') {
					fieldValue = fieldEl.is(':checked');
				} else {
					fieldValue = fieldEl.val();
				}

				let result = this.compare(value, fieldValue, compare);

				if (result) {
					trueResults++;
				} else {
					falseResults++;
				}

				if (trueResults > 0 && 'or' === relation) {
					showField = true;
					break;
				}
			}

			if (0 === falseResults) {
				showField = true;
			}

			if (showField) {
				el.closest('.c-form__group').removeClass('hidden');
			} else {
				el.closest('.c-form__group').addClass('hidden');
			}
		}

		/**
		 * Compare expected and actual value using given operator.
		 *
		 * @param	{mixed} expected
		 * @param 	{mixed} actual
		 * @param 	{string} operator
		 * @returns {boolean}
		 * @since   1.0.0
		 */
		compare(expected, actual, operator)
		{
			switch (operator) {
				case '=':
					return actual === expected;
				case '!=':
					return actual !== expected;
				case '<':
					return actual < expected;
				case '<=':
					return actual <= expected;
				case '>':
					return actual > expected;
				case '>=':
					return actual >= expected;
				case 'in':
					return expected.toString().split(',').includes(actual.toString());
				case 'not_in':
					return !expected.toString().split(',').includes(actual.toString());
				default:
					return false;
			}
		}
	}

	moduleRegistrar.register(new Module('webscape-contextual-form', ContextualForm));

	$(document).ready(function () {
		moduleRegistrar.instantiate('webscape-contextual-form');
	});
})(
	window,
	jQuery,
	window.webSCAPE.moduleRegistrar,
	window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    undefined
) {
    /**
     *
     * @param str
     * @return {*}
     */
    function sprintf(str)
    {
        let args = arguments, i = 1;

        return str.replace(/%(s|d|0\d+d)/g, function (x, type) {
            let value = args[i++];
            switch (type) {
                case 's':
                    return value;
                case 'd':
                    return parseInt(value, 10);
                default:
                    value = String(parseInt(value, 10));
                    let n = Number(type.slice(1, -1));
                    return '0'.repeat(n).slice(value.length) + value;
            }
        });
    }

    let validationMessages = global.validation_messages;

    /**
     * Abstract rule class.
     */
    class AbstractRule
    {
        /**
         * Retrieves the validation message.
         *
         * @param  {string} messageKey
         * @param  {string|null} field
         * @param  {string|number|null} param
         * @return {string}
         * @since  1.0.0
         */
        getMessage(messageKey, field = null, param = null)
        {
            let message;
            let customMessage = $(this.fieldId(field)).data('error-message-' + messageKey);

            if (null !== field && customMessage && '' !== customMessage) {
                message = customMessage;
            } else {
                message = validationMessages[messageKey];
            }

            // Use field label as field name in error message.
            let fieldName = $(this.fieldId(field)).prev('label').html();

            if (null !== param) {
                return sprintf(message, fieldName, param);
            }

            if (null !== field) {
                return sprintf(message, fieldName);
            }

            return sprintf(message);
        }

        /**
         * Returns the field ID selector.
         *
         * @returns {string}
         * @since    1.0.0
         */
        fieldId(field)
        {
            return '#' + field;
        }
    }

    /**
     * Optional rule class.
     */
    class OptionalRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} field
         * @param  {mixed}  value
         * @return {boolean}
         * @since  1.0.0
         */
        passes(field, value)
        {
            return true;
        }

        /**
         * Retrieves the rules validation message.
         *
         * @return {string}
         * @since  1.0.0
         */
        message()
        {
            return '';
        }
    }

    /**
     * Required rule class.
     */
    class RequiredRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} field
         * @param  {string|number|boolean}  value
         * @return {boolean}
         * @since  1.0.0
         */
        passes(field, value)
        {
            if ($(this.fieldId(field)).attr('type') === 'radio') {
                return $('[name="' + $(this.fieldId(field)).attr('name') + '"]:checked').length;
            }

            if (typeof value === 'string') {
                return '' !== value.trim();
            }

            if (typeof value === 'number') {
                return value || 0 === value;
            }

            if (typeof value === 'boolean') {
                return value;
            }

            return true;
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} field
         * @return {string}
         * @since  1.0.0
         */
        message(field)
        {
            return this.getMessage('required', field);
        }
    }

    /**
     * Require n fields to be set within the fieldset group class.
     */
    class RequireNRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} field
         * @param  {number}  required
         * @param  {string|number|boolean}  value
         * @return {boolean}
         * @since  1.0.0
         */
        passes(field, required, value)
        {
            const fieldSet = $(this.fieldId(field)).data('fieldset');
            let fieldsWithValue = 0;

            $('[data-fieldset="' + fieldSet + '"]').each((index, el) => {
                if ($(el).attr('type') === 'radio' || $(el).attr('type') === 'checkbox') {
                    if ($(el).prop('checked')) {
                        fieldsWithValue++;
                    }

                    return;
                }

                if (typeof value === 'string' && '' !== value.trim()) {
                    fieldsWithValue++;
                    return;
                }

                if (typeof value === 'number' && value || 0 === value) {
                    fieldsWithValue++;
                    return;
                }

                if (typeof value === 'boolean' && value) {
                    fieldsWithValue++;
                    return;
                }
            });

            return fieldsWithValue >= required;
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} field
         * @return {string}
         * @since  1.0.0
         */
        message(field)
        {
            return this.getMessage('require_n', field);
        }
    }

    /**
     * Min length rule class.
     */
    class MinLength extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {number} minLength
         * @param  {string} stringValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, minLength, stringValue)
        {
            return stringValue.length >= minLength;
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @param  {number} minLength
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey, minLength)
        {
            return this.getMessage('min_length', fieldKey, minLength);
        }
    }

    /**
     * Max length rule class.
     */
    class MaxLength extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {number} maxLength
         * @param  {string} stringValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, maxLength, stringValue)
        {
            return stringValue.length <= maxLength;
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @param  {number} maxLength
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey, maxLength)
        {
            return this.getMessage('max_length', fieldKey, maxLength);
        }
    }

    /**
     * Min date rule class.
     */
    class MinDate extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} minDate
         * @param  {string} actualDate
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, minDate, actualDate)
        {
            let dateValues = actualDate.split('-');
            let minDateValue = minDate.split('-');

            if (dateValues.length < 3 || minDateValue.length < 3) {
                return false;
            }

            return new Date(
                parseInt(dateValues[0], 10),
                parseInt(dateValues[1], 10),
                parseInt(dateValues[2], 10)
            ) >= new Date(
                parseInt(minDateValue[0], 10),
                parseInt(minDateValue[1], 10),
                parseInt(minDateValue[2], 10)
            );
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @param  {string} minDate
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey, minDate)
        {
            return this.getMessage('min_date', fieldKey, minDate);
        }
    }

    /**
     * Min date rule class.
     */
    class MaxDate extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} maxDate
         * @param  {string} actualDate
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, maxDate, actualDate)
        {
            let dateValues = actualDate.split('-');
            let maxDateValue = maxDate.split('-');

            if (dateValues.length < 3 || maxDateValue.length < 3) {
                return false;
            }

            return new Date(
                parseInt(dateValues[0], 10),
                parseInt(dateValues[1], 10),
                parseInt(dateValues[2], 10)
            ) <= new Date(
                parseInt(maxDateValue[0], 10),
                parseInt(maxDateValue[1], 10),
                parseInt(maxDateValue[2], 10)
            );
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @param  {string} maxDate
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey, maxDate)
        {
            return this.getMessage('max_date', fieldKey, maxDate);
        }
    }

    /**
     * Alpha with spaces rule class.
     */
    class AlphaWithSpacesRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} stringValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, stringValue)
        {
            return '' === stringValue.trim() || /^[a-zA-ZäöüßÄÖÜ\s]+$/.test(stringValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('alpha_with_spaces', fieldKey, '[a-zA-ZäöüßÄÖÜ ]');
        }
    }

    /**
     * Alpha with spaces rule class.
     */
    class GenericTextRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} stringValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, stringValue)
        {
            return '' === stringValue.trim() || /^[0-9a-zA-ZäöüßÄÖÜ&@€$§#()\s.:,;_=+\-*/!?^°"'´`]+$/.test(stringValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('generic_text', fieldKey, '[0-9a-zA-ZäöüßÄÖÜ&@€$§#()\s.:,;_=+\-*/!?^°"\'´` ]');
        }
    }

    /**
     * Street rule class.
     */
    class StreetRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} streetValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, streetValue)
        {
            return /^[a-zA-ZäöüßÄÖÜ0-9\s-.,/()]+$/.test(streetValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('street', fieldKey, '[a-zA-ZäöüßÄÖÜ0-9 ()/-.,]');
        }
    }

    /**
     * ZIP code rule class.
     */
    class ZipCodeRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} zipCodeValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, zipCodeValue)
        {
            return /^[0-9]{4,5}$/.test(zipCodeValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('zip_code', fieldKey);
        }
    }

    /**
     * Email rule class.
     */
    class EmailRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} emailValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, emailValue)
        {
            return /^\d{5}$/.test(emailValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('email', fieldKey);
        }
    }

    /**
     * Phone rule class.
     */
    class PhoneRule extends AbstractRule
    {
        /**
         * Validates the rule.
         *
         * @param  {string} fieldKey
         * @param  {string} phoneValue
         * @return {boolean}
         * @since  1.0.0
         */
        passes(fieldKey, phoneValue)
        {
            return /^((\+[0-9]{1,4})?|([0-9]{1,4}))?(\d\s)+$/.test(phoneValue)
        }

        /**
         * Retrieves the rules validation message.
         *
         * @param  {string} fieldKey
         * @return {string}
         * @since  1.0.0
         */
        message(fieldKey)
        {
            return this.getMessage('phone', fieldKey);
        }
    }

    /**
     * Rule map class.
     */
    class RuleMap
    {
        /**
         * Rules strings to classes map.
         *
         * @type  {{Object}}
         */
        map = {
            optional: OptionalRule,
            required: RequiredRule,
            require_n: RequireNRule,
            street: StreetRule,
            zip_code: ZipCodeRule,
            email: EmailRule,
            phone: PhoneRule,
            generic_text: GenericTextRule,
            alpha_with_spaces: AlphaWithSpacesRule,
            min_length: MinLength,
            max_length: MaxLength,
            min_date: MinDate,
            max_date: MaxDate,
        };

        /**
         * Resolves rule class from string.
         *
         * @param  {string} rule
         * @return {Object}
         * @since  1.0.0
         */
        resolve(rule)
        {
            return new (this.map[rule])();
        }
    }

    /**
     * Rule validator class.
     */
    class FormValidator
    {
        /**
         * Fields data to validate against.
         *
         * @type  {Object}
         */
        data = {};

        /**
         * Fields validation rules.
         *
         * @type  {Object}
         */
        rules = {};

        /**
         * Validation errors.
         *
         * @type  {Object}
         */
        errors = {};

        /**
         * Rule map instance.
         *
         * @type  {RuleMap|null}
         */
        ruleMap = null;

        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            error: '.has-error',
            errorOutput: '.js-form-input-error',
            formInputError: '.c-form__input-error',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            error: 'has-error',
            errorOutput: 'js-form-input-error',
            formInputError: 'c-form__input-error',
        };

        /**
         * @param {Object} data
         * @param {Object} rules
         */
        constructor(data, rules)
        {
            this.init();

            if ($(this.selectors.errorOutput.length)) {
                //this.getFormErrors();
            }
        }

        init(data, rules)
        {
            this.data = data;
            this.rules = rules;
            this.errors = {};
            this.ruleMap = new RuleMap();
        }

        /**
         * Retrieves errors present in form.
         *
         * @returns {void}
         * @since    1.0.0
         */
        getFormErrors()
        {
            for (const field in this.data) {
                if (this.rules.hasOwnProperty(field)) {
                    this.rules[field].forEach(rule => {
                        if ($(this.fieldId(field)).next(this.selectors.errorOutput).find('[data-field-error="' + rule + '"]')) {
                            if (! this.errors.hasOwnProperty(field)) {
                                this.errors[field] = {};
                            }
                            this.errors[field][rule] = $(this.fieldId(field)).next(this.selectors.errorOutput).find('[data-field-error="' + rule + '"]').html();
                        }
                    });
                }
            }
        }

        /**
         * Retrieves the field value by key.
         *
         * @param    {string} field
         * @returns {*|null}
         * @since    1.0.0
         */
        getFieldValue(field)
        {
            return this.data[field];
        }

        /**
         * Resolves rule classe from rule string.
         *
         * @param    {string} rule
         * @returns {*}
         */
        getRuleFromString(rule)
        {
            return this.ruleMap.resolve(rule);
        }

        /**
         * Validates all rules against field values.
         *
         * @returns {boolean}
         */
        validate()
        {
            // Apply to all fields in data object.
            Object.keys(this.data).map(field => {
                // Skip if no rule for field defined.
                if (! this.rules.hasOwnProperty(field)) {
                    return;
                }

                // Get rules of field.
                this.rules[field].forEach(rule => {
                    this.validateRule(field, rule, this.hasOptionalRule(this.rules[field]));
                });
            });

            return ! this.hasErrors();
        }

        /**
         * Validates single rule against field.
         *
         * @param    {string} field
         * @param    {string} rule
         * @param    {boolean} optional
         * @returns {void}
         * @since    1.0.0
         */
        validateRule(field, rule, optional = false)
        {
            let value = this.getFieldValue(field);
            let passed = false;
            let param = null;

            // Rule is optional and value empty, abort validation.
            if ((typeof value === 'string' && '' === value.trim() || ! value) && optional) {
                return;
            }

            // Rule with parameter, for example max length rule.
            if (rule.indexOf(':') > 0) {
                let ruleParts = rule.split(':');
                rule = ruleParts[0];
                param = ruleParts[1];
            }

            // Get rule class instance.
            let ruleObj = this.getRuleFromString(rule);

            // Check if the rule passes.
            if (null !== param) {
                passed = ruleObj.passes(field, param, value);
            } else {
                passed = ruleObj.passes(field, value);
            }

            // Remove the error if the rule did pass.
            if (true === passed) {
                this.removeError(rule, field);
                return;
            }

            // Add error if rule didn't pass.
            if (null !== param) {
                this.addError(rule, field, ruleObj.message(field, param));
            } else {
                this.addError(rule, field, ruleObj.message(field));
            }
        }

        /**
         * Verifies if there is an optional rule in the ruleset.
         *
         * @param   {array} rules
         * @returns {boolean}
         * @since    1.0.0
         */
        hasOptionalRule(rules)
        {
            for (let rule of rules) {
                if (rule.indexOf(':') > 0) {
                    rule = rule.split(':')[0];
                }

                if (this.getRuleFromString(rule) instanceof OptionalRule) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Adds error to error object and form.
         *
         * @param {string} rule
         * @param {string} field
         * @param {string} message
         */
        addError(rule, field, message)
        {
            if (! this.errors.hasOwnProperty(field)) {
                this.errors[field] = {};
            }

            this.errors[field][rule] = message;

            $(this.fieldId(field)).parent().addClass(this.classes.error);
            $(this.fieldId(field)).next(this.selectors.formInputError).remove();

            let errors = [];

            for (let rule in this.errors[field]) {
                if (! rule) {
                    continue;
                }

                errors.push(`<li data-field-error="${ rule }">${ this.errors[field][rule] }</li>`);
            }

            $(this.fieldId(field)).after(`<ul class="${ this.classes.formInputError } unstyled ${ this.classes.errorOutput }">${ errors.join('') }</ul>`);
        }

        /**
         * Removes error from error object and form.
         *
         * @param {string} rule
         * @param {string} field
         */
        removeError(rule, field)
        {
            $(this.fieldId(field)).next(this.selectors.errorOutput).find('li[data-field-error="' + rule + '"]').remove();

            if (! this.hasErrors()) {
                return;
            }

            if (this.errors.hasOwnProperty(field)) {
                if (Object.keys(this.errors[field]).length > 0) {
                    if (this.errors[field].hasOwnProperty(rule)) {
                        delete this.errors[field][rule];
                    }
                } else {
                    delete this.errors[field];
                }
            }
        }

        /**
         * Verifies if there are errors.
         *
         * @returns {boolean}
         * @since    1.0.0
         */
        hasErrors()
        {
            return Object.keys(this.errors).length > 0;
        }

        /**
         * Returns the field ID selector.
         *
         * @returns {string}
         * @since    1.0.0
         */
        fieldId(field)
        {
            return '#' + field;
        }
    }

    moduleRegistrar.register(new Module('webscape-form-validator', FormValidator));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    moduleRegistrar,
    Module,
    undefined
) {
    class ImageHelper
    {
        /**
         * Image source URL.
         *
         * @type {string}
         */
        url = '';

        /**
         * Image.
         *
         * @type {HTMLImageElement|null}
         */
        img = null;

        /**
         * Image loaded.
         *
         * @type {boolean}
         */
        loaded = false;

        /**
         * Image width.
         *
         * @type {number}
         */
        width = 0;

        /**
         * Image height.
         *
         * @type {number}
         */
        height = 0;


        /**
         * @param {string} url
         */
        constructor(url)
        {
            this.url = url;
        }

        /**
         * Checks if image source is loaded.
         *
         * @return {Promise}
         */
        isLoaded()
        {
            return new Promise((resolve, reject) => {
                this.img = new Image();
                this.img.addEventListener('load', () => {
                    this.loaded = true;
                    this.width = this.img.width;
                    this.height = this.img.height;
                    return resolve(this);
                });
                this.img.addEventListener('error', reject);
                this.img.src = this.url;
            });
        }

        /**
         * Retrieves the width of the image.
         *
         * @returns {number}
         */
        getWidth()
        {
            return this.width;
        }

        /**
         * Retrieves the height of the image.
         *
         * @returns {number}
         */
        getHeight()
        {
            return this.height;
        }
    }

    moduleRegistrar.register(new Module('webscape-image-helper', ImageHelper));
})(
    window,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    ImageHelper,
    Throttle,
    undefined
) {
    /**
     * webSCAPE slider class.
     */
    class Slider
    {
        /**
         * HTML ids.
         *
         * @type  {Object}
         */
        ids = {};

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            active: 'active',
            prev: 'prev',
            next: 'next',
            inTransition: 'in-transition',
        };

        /**
         * @param {string|null} id
         * @param {Object} options
         */
        constructor(id, options = {})
        {
            this.options = Object.assign({
                transitionDuration: 600,
                slideshow: false,
                slideshowInterval: 8,
                pauseOnAction: false,
                pauseOnActionTimeout: 30,
                pauseWhileHover: false,
                initialSlide: 0,
                colums: 1,
                scrollColumns: 1,
                responsive: false,
                navigation: 'simple',
                transition: 'cross-fade',
                autoHeight: false,
                showItems: 3,
            }, options);

            this.container = null;
            this.slides = null;
            this.sliderItems = [];
            this.activeSlide = null;
            this.loadingAnimation = null;
            this.userActionTimeout = null;
            this.autoSlideTimer = null;

            this.ids.container = id;

            /**
             * Element selectors.
             *
             * @type {Object}
             */
            this.selectors = {
                container: '#' + this.ids.container,
                active: '.' + this.classes.active,
                prev: '.' + this.classes.prev,
                next: '.' + this.classes.next,
                prevInTransition: '.' + this.classes.prev + '.' + this.classes.inTransition,
                nextInTransition: '.' + this.classes.next + '.' + this.classes.inTransition,
                inTransition: '.' + this.classes.inTransition,
                navigation: '[data-js~="slider-nav"]',
                navigationPrev: '[data-js~="slider-prev"]',
                navigationNext: '[data-js~="slider-next"]',
                indicator: '[data-js="slider-indicator"]',
                slidesContainer: '[data-js="slider-items"]',
                slide: '[data-js~="slider-item"]',
                loadingSpinner: '[data-js="slider-loading"]',
            };

            this.clientX = 0;
            this.touchOffset = 0;
            this.sliderItemsCount = 0;
            this.slideIndex = 0;

            this.initSlider();
        }

        /**
         * Initializes slider, sets up events.
         */
        initSlider()
        {
            // Get lightbox element.
            this.container = $(this.selectors.container);

            // Get slider indicator.
            this.indicator = $(this.selectors.indicator);

            // Get slider loading animation element.
            this.loadingAnimation = $(this.selectors.loadingSpinner);

            // Auto-height option.
            if (this.options.autoHeight) {
                this.container.find(this.selectors.slide).each((index, slide) => {
                    $(slide).attr('data-height', $(slide).outerHeight() + 'px');
                });
            }

            // Set first slide to active, if no slide is active.
            if (! this.container.find(this.selectors.slide + this.selectors.active).length) {
                this.container.find(this.selectors.slide).first().addClass(this.classes.active);
            }

            // Get all slider slides.
            this.sliderItemsCount = this.getAllSlides().length;
            this.sliderItems = [...Array(this.sliderItemsCount).keys()];

            // Initialize the first slide-set.
            this.setSlideSetClasses(this.getIterationSlidesSet());

            // Show loading animation.
            this.loadingAnimation.addClass(this.classes.active);

            this.getFirstSlide(true).before(this.getLastSlide(true));

            if (this.options.autoHeight) {
                this.container.css('height', this.activeSlide.data('height'));
            }

            this.container.attr('data-loaded', 'true');

            // Set up click and touch events.
            this.container.off();
            let clickEventsThrottled = new Throttle(this.clickEvents, this.options.transitionDuration);

            let _this = this;
            this.container.on('click', e => clickEventsThrottled(e, _this));

            this.container.on('touchstart', e => {
                e.target.clientX = e.originalEvent.touches.item(0).clientX;
            });

            this.container.on('touchend', e => {
                let target = e.target;
                this.touchOffset = target.clientX - e.originalEvent.changedTouches.item(0).clientX;
                if (this.touchOffset > 80 || target.touchOffset < -80) {
                    // this.prepareSlides();
                    if (this.clientX > e.originalEvent.changedTouches.item(0).clientX) {
                        this.nextSlide();
                    } else {
                        this.prevSlide();
                    }
                }
            });

            if (this.options.slideshow) {
                this.autoSlide();
            }

            $(window).on('blur', () => {
                this.clearTimers();
            });

            $(window).on('focus', () => {
                this.clearTimers();

                if (this.options.slideshow) {
                    this.autoSlide();
                }
            });
        }

        /**
         * Sets slide properties.
         *
         * @param {Object} slide
         */
        setSlideProperties(slide)
        {
            slide.addClass(this.classes.next);
        }

        /**
         * Retrieves all slides.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getAllSlides(cached = false)
        {
            if (cached && this.slides) {
                return this.slides;
            }

            this.slides = this.container.find(this.selectors.slide);
            return this.slides;
        }

        /**
         * Retrieves the first slide.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getFirstSlide(cached = false)
        {
            return this.getAllSlides(cached).first();
        }

        /**
         * Retrieves the last slide.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getLastSlide(cached = false)
        {
            return this.getAllSlides(cached).last();
        }

        /**
         * Retrieves the active slide.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getActiveSlide(cached = false)
        {
            if (cached && this.activeSlide) {
                return this.activeSlide;
            }

            this.activeSlide = this.container.find(this.selectors.slide + this.selectors.active);
            return this.activeSlide;
        }

        /**
         * Retrieves the slide before the active one.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getPrevSlide(cached = false)
        {
            return this.getActiveSlide(cached).prev();
        }

        /**
         * Retrieves the slide after the active one.
         *
         * @param   {Boolean} cached
         * @returns {jQuery|null}
         * @since   1.0.0
         */
        getNextSlide(cached = false)
        {
            return this.getActiveSlide(cached).next();
        }

        /**
         * Retrieves a slide-set (active, prev, and next slides) for the given direction.
         *
         * @param direction
         * @returns {{next: number[], prev: number[], active: number}}
         */
        getIterationSlidesSet(direction = 'init')
        {
            let newPrevSlide = 0;
            let newNextSlide = 0;

            if ('init' === direction) {
                this.slideIndex = 0;
            } else if ('next' === direction) {
                if (this.slideIndex < (this.sliderItemsCount - 1)) {
                    this.slideIndex++;
                } else {
                    this.slideIndex = 0;
                }
            } else {
                if (this.slideIndex > 0) {
                    this.slideIndex--;
                } else {
                    this.slideIndex = this.sliderItemsCount - 1;
                }
            }

            if (0 === this.slideIndex) {
                newPrevSlide = this.sliderItemsCount - 1;
            } else {
                newPrevSlide = this.slideIndex - 1;
            }

            if ((this.sliderItemsCount - 1) === this.slideIndex) {
                newNextSlide = 0;
            } else {
                newNextSlide = this.slideIndex + 1;
            }

            if (this.options.showItems > 1) {
                if (this.options.showItems % 2 === 0) {
                    this.options.showItems++;
                }
            }

            let slideSet = {
                prev: [
                    newPrevSlide,
                ],
                active: this.slideIndex,
                next: [
                    newNextSlide,
                ]
            };

            let additionalPrevNext = (this.options.showItems - 1) / 2;

            for (let i = 1; i <= additionalPrevNext; i++) {
                newPrevSlide--;
                if (newPrevSlide < 0) {
                    newPrevSlide = this.sliderItemsCount - 1
                }

                slideSet.prev[i] = newPrevSlide;

                newNextSlide++;
                if (newNextSlide > this.sliderItemsCount - 1) {
                    newNextSlide = 0
                }

                slideSet.next[i] = newNextSlide;
            }

            return slideSet;
        }

        /**
         * Retrieves a slide selector by the slide index.
         *
         * @param   {Number} index
         * @returns {String}
         * @since   1.0.0
         */
        getSlideSelectorByIndex(index)
        {
            return this.selectors.slide + '[data-index="' + index + '"]';
        }

        /**
         * Sets the CSS classes for the given slide-set.
         *
         * @param {Object} slideSet
         */
        setSlideSetClasses(slideSet)
        {
            $(document).trigger('webscape_slider_before_set_slideset_classes');

            this.getAllSlides().addClass(this.classes.inTransition);

            this.container.find(this.getSlideSelectorByIndex(slideSet.active))
                .addClass(this.classes.active)
                .attr('data-offset', 0)
                .removeClass(this.classes.prev)
                .removeClass(this.classes.next)
                .css({
                    zIndex: this.sliderItemsCount,
                });

            slideSet.prev.forEach((value, index) => {
                this.container.find(this.getSlideSelectorByIndex(value))
                    .addClass(this.classes.prev)
                    .attr('data-offset', index + 1)
                    .removeClass(this.classes.active)
                    .removeClass(this.classes.next)
                    .css({
                        zIndex: this.sliderItemsCount - index - 1,
                    });
            });

            slideSet.next.forEach((value, index) => {
                this.container.find(this.getSlideSelectorByIndex(value))
                    .addClass(this.classes.next)
                    .attr('data-offset', index + 1)
                    .removeClass(this.classes.prev)
                    .removeClass(this.classes.active)
                    .css({
                        zIndex: this.sliderItemsCount - index - 1,
                    });
            });

            setTimeout(() => {
                this.container.find(this.getSlideSelectorByIndex(slideSet.active))
                    .css({
                        zIndex: this.sliderItemsCount,
                    });

                slideSet.prev.forEach((value, index) => {
                    this.container.find(this.getSlideSelectorByIndex(value))
                        .css({
                            zIndex: this.sliderItemsCount - index - 1,
                        });
                });

                slideSet.next.forEach((value, index) => {
                    this.container.find(this.getSlideSelectorByIndex(value))
                        .css({
                            zIndex: this.sliderItemsCount - index - 1,
                        });
                });

                this.getAllSlides().removeClass(this.classes.inTransition);

                $(document).trigger('webscape_slider_after_set_slideset_classes');
            }, this.options.transitionDuration);
        }

        /**
         * Navigates to the previous slide.
         */
        prevSlide()
        {
            // Move the last slide before the first to allow infinite image loop.
            if (! this.getLastSlide().hasClass(this.classes.active)) {
                this.getFirstSlide(true).before(this.getLastSlide(true));
            }

            $(this.selectors.container).trigger(
                'webscape_slider_before_set_slide',
                {
                    slide: this.getPrevSlide(),
                }
            );

            // Check if previous slide image is loaded.
            let sliderImage = this.getPrevSlide().find('img');
            if (sliderImage.length) {
                new ImageHelper(sliderImage.attr('src')).isLoaded().then(() => {
                    this.setPrevSlide();
                }).catch(err => console.error(err));
            } else {
                this.setPrevSlide();
            }
        }

        /**
         * Sets the previous slide.
         */
        setPrevSlide()
        {
            this.setSlideSetClasses(this.getIterationSlidesSet('prev'));

            $(document).trigger(
                'webscape_slider_before_transition',
                {
                    direction: 'prev',
                }
            );

            // Remove loading animation.
            this.loadingAnimation.removeClass(this.classes.active);

            // Set height.
            if (this.options.autoHeight) {
                this.container.css('height', this.getActiveSlide().data('height'));
            }

            // Set slider indicator.
            this.setIndicator();

            $(document).trigger(
                'webscape_slider_after_transition',
                {
                    direction: 'prev',
                }
            );
        }

        /**
         * Navigates to the next slide.
         */
        nextSlide()
        {
            // Move the first slide to the end to allow infinite image loop.
            if (! this.getFirstSlide().hasClass(this.classes.active)) {
                this.getLastSlide(true).after(this.getFirstSlide(true));
            }

            $(this.selectors.container).trigger(
                'webscape_slider_before_set_slide',
                {
                    slide: this.getNextSlide(),
                }
            );

            // Check if next slide image is loaded.
            let sliderImage = this.getNextSlide().find('img');
            if (sliderImage.length) {
                new ImageHelper(sliderImage.attr('src')).isLoaded().then(() => {
                    this.setNextSlide();
                }).catch(err => console.error(err));
            } else {
                this.setNextSlide();
            }
        }

        /**
         * Sets the next slide.
         */
        setNextSlide()
        {
            this.setSlideSetClasses(this.getIterationSlidesSet('next'));

            $(document).trigger(
                'webscape_slider_before_transition',
                {
                    direction: 'next',
                }
            );

            // Remove loading animation.
            this.loadingAnimation.removeClass(this.classes.active);

            // Set height.
            if (this.options.autoHeight) {
                this.container.css('height', this.getActiveSlide().data('height'));
            }

            // Set slider indicator.
            this.setIndicator();

            $(document).trigger(
                'webscape_slider_after_transition',
                {
                    direction: 'next',
                }
            );
        }

        /**
         * Clears all intervals and timeouts.
         */
        clearTimers()
        {
            clearInterval(this.autoSlideTimer);
            clearTimeout(this.userActionTimeout);
            this.autoSlideTimer = null;
            this.userActionTimeout = null;
        }

        /**
         * Auto slide by interval.
         */
        autoSlide()
        {
            this.clearTimers();
            // this.prepareSlides();
            this.setIndicator();

            this.autoSlideTimer = setInterval(() => {
                // this.prepareSlides();
                this.nextSlide();
            }, this.options.slideshowInterval * 1000);
        }

        /**
         * Sets timeout when user is interacting.
         */
        pauseOnActionTimeout()
        {
            this.clearTimers();

            this.userActionTimeout = setTimeout(() => {
                if (this.options.slideshow) {
                    this.autoSlide();
                }
            }, this.options.pauseOnActionTimeout * 1000);
        }

        /**
         * Sets indicator when clicking next or previous slide.
         */
        setIndicator()
        {
            // this.slideIndex = this.activeSlide.data('index');
            this.indicator.find(this.selectors.active).removeClass(this.classes.active);
            this.indicator.find('[data-index="' + this.slideIndex + '"]').addClass(this.classes.active);
        }

        /**
         * Goes to slide by id when clicking on indicator.
         */
        goToSlide(index)
        {
            $(document).trigger('webscape-slider-before-transition');

            setTimeout(() => {
                this.container.find(this.selectors.slide + this.selectors.prev).removeClass(this.classes.prev);
                this.container.find(this.selectors.slide + this.selectors.next).removeClass(this.classes.next);
            }, this.options.transitionDuration);

            if (this.slideIndex > index) {
                this.getActiveSlide().addClass(this.classes.prev);
            }

            if (this.slideIndex < index) {
                this.getActiveSlide().addClass(this.classes.next);
            }

            this.slides.removeClass(this.classes.active);
            this.activeSlide = this.container.find(this.selectors.slide + '[data-index="' + index + '"]').addClass(this.classes.active);

            if (this.slides.first().hasClass(this.classes.active)) {
                this.slides.first().before(this.slides.last());
            }

            if (this.slides.last().hasClass(this.classes.active)) {
                this.slides.last().after(this.slides.first());
            }

            this.slideIndex = index;

            this.setIndicator();

            $(document).trigger('webscape-slider-transition-completed');
        }

        /**
         * Sets up click events.
         */
        clickEvents(e, _this)
        {
            let target = e.target;

            if ($(target).data('js') && $(target).data('js').indexOf('slider-prev') >= 0) {
                _this.pauseOnActionTimeout();
                _this.prevSlide();
                return;
            }

            if ($(target).data('js') && $(target).data('js').indexOf('slider-next') >= 0) {
                _this.pauseOnActionTimeout();
                _this.nextSlide();
                return;
            }

            if ($(target).parent().data('js') && $(target).parent().data('js').indexOf('slider-indicator') >= 0) {
                _this.pauseOnActionTimeout();
                _this.goToSlide($(target).data('index'));
            }
        }
    }

    moduleRegistrar.register(new Module('webscape-slider', Slider));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-image-helper').getClass(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-throttle').getClass()
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    undefined
) {
    class Toggle
    {
        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            toggle: '[data-js="toggle"]',
            toggleTarget: '[data-js="toggle_target"]',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            active: 'active',
        };

        /**
         * @param {jQuery} toggle
         */
        constructor(toggle)
        {
            this.target = $(toggle).data('toggleTarget');
            this.toggleClass = $(toggle).data('toggleClass') || this.classes.active;

            $(toggle).on('click', () => {
                $(this.selectors.toggleTarget + '[data-toggle="' + this.target + '"]').toggleClass(this.toggleClass);
            });
        }
    }

    moduleRegistrar.register(new Module('webscape-toggle', Toggle, '[data-js="toggle"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    localStorage,
    undefined
) {
    class Tabs
    {
        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            tabs: '[data-js="tabs"]',
            tabToggle: '[data-js="tab-toggle"]',
            tabContent: '[data-js="tab-content"]',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            active: 'active',
        };

        /**
         * Active tab.
         *
         * @type {jQuery|null}
         */
        activeTab = null;

        /**
         * @param {jQuery} tabs
         */
        constructor(tabs)
        {
            this.id = $(tabs).data('tabs');

            this.activeTab = localStorage.get(this.id);

            if (this.activeTab && 'undefined' !== this.activeTab) {
                $(tabs).find(this.selectors.tabToggle).removeClass(this.classes.active);
                $(tabs).find(this.selectors.tabToggle + '[data-tab="' + this.activeTab + '"]').addClass(this.classes.active);
                $(tabs).find(this.selectors.tabContent).removeClass(this.classes.active);
                $(tabs).find(this.selectors.tabContent + '[data-tab="' + this.activeTab + '"]').addClass(this.classes.active);
            } else {
                $(tabs).find(this.selectors.tabToggle).first().addClass(this.classes.active);
                this.activeTab = $(tabs).find(this.selectors.tabToggle).first().data('tab');
                $(tabs).find(this.selectors.tabContent + '[data-tab="' + this.activeTab + '"]').addClass(this.classes.active);
            }

            $(tabs).find(this.selectors.tabToggle).on('click', (e) => {
                $(tabs).find(this.selectors.tabToggle).removeClass(this.classes.active);
                $(e.currentTarget).addClass(this.classes.active);
                $(tabs).find(this.selectors.tabContent).removeClass(this.classes.active);
                $(tabs).find(this.selectors.tabContent + '[data-tab="' + $(e.currentTarget).data('tab') + '"]').addClass(this.classes.active);

                localStorage.set(this.id, $(e.currentTarget).data('tab'));
            });
        }
    }

    moduleRegistrar.register(new Module('webscape-tabs', Tabs, '[data-js="tabs"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-local-storage').getInstance()
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    undefined
) {
    class Collapsible
    {
        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            collapsible: '[data-js="collapsible"]',
            collapsibleHeading: '[data-js="collapsible-heading"]',
            collapsibleToggleIcon: '[data-js="collapsible-toogle-icon"]',
            collapsiblePreview: '[data-js="collapsible-preview"]',
            collapsibleContent: '[data-js="collapsible-content"]',
            collapsibleExpand: '[data-js="collapsible-expand"]',
            collapsibleCollapse: '[data-js="collapsible-collapse"]',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            expanded: 'expanded',
            collapsed: 'collapsed',
            iconExpanded: 'icon-arrow-up-circle',
            iconCollapsed: 'icon-arrow-down-circle',
        };

        constructor(collapsible)
        {
            if ($(collapsible).hasClass(this.classes.expanded)) {
                this.expand(collapsible);
            } else {
                this.collapse(collapsible);
            }

            $(collapsible).find(this.selectors.collapsibleHeading).on('click', e => {
                if ($(collapsible).hasClass(this.classes.expanded)) {
                    this.collapse(collapsible);
                } else {
                    this.expand(collapsible);
                }
            });

            $(collapsible).find(this.selectors.collapsibleExpand).on('click', e => {
                this.expand(collapsible);
            });

            $(collapsible).find(this.selectors.collapsibleCollapse).on('click', e => {
                this.collapse(collapsible);
            });
        }

        /**
         * Expands the collapsible.
         *
         * @param {jQuery} collapsible
         */
        expand(collapsible)
        {
            if ($(collapsible).data('autocollapse')) {
                $(this.selectors.collapsible + '[data-group="' + $(collapsible).data('group') + '"]').each((index, collapsible) => {
                    this.collapse(collapsible);
                });
            }

            $(collapsible).addClass(this.classes.expanded).removeClass(this.classes.collapsed);

            let preview = $(collapsible).find(this.selectors.collapsiblePreview);
            if (preview.length) {
                preview.css({ maxHeight: 0 });
            }

            $(collapsible).find(this.selectors.collapsibleContent).css({ maxHeight: $(collapsible).find(this.selectors.collapsibleContent)[0].scrollHeight + 'px' });

            let icon = $(collapsible).find(this.selectors.collapsibleToggleIcon);
            if (icon.length) {
                icon.removeClass(this.classes.iconCollapsed).addClass(this.classes.iconExpanded);
            }

            $(collapsible).attr('aria-expanded', 'true');
        }

        /**
         * Collapses the collapsible.
         *
         * @param {jQuery} collapsible
         */
        collapse(collapsible)
        {
            $(collapsible).removeClass(this.classes.expanded).addClass(this.classes.collapsed);

            let preview = $(collapsible).find(this.selectors.collapsiblePreview);
            if (preview.length) {
                preview.css({ maxHeight: preview[0].scrollHeight + 'px' });
            }

            $(collapsible).find(this.selectors.collapsibleContent).css({ maxHeight: 0 });

            let icon = $(collapsible).find(this.selectors.collapsibleToggleIcon);
            if (icon.length) {
                icon.removeClass(this.classes.iconExpanded).addClass(this.classes.iconCollapsed);
            }

            $(collapsible).attr('aria-expanded', 'false');
        }
    }

    moduleRegistrar.register(new Module('webscape-collapsible', Collapsible, '[data-js="collapsible"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module
) {
    class Modal
    {
        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            modal: '[data-js="modal"]',
            modalContent: '[data-js="modal-content"]',
            modalClose: '[data-js="modal-close"]',
            modalCloseAlt: '.js-modal-close',
            modalConfirm: '[data-js="modal-confirm"]',
            modalAbort: '[data-js="modal-abort"]',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            active: 'active',
            noScroll: 'no-scroll',
        };

        // Modal ID.
        id = null;

        // Auto show modal.
        autoShow = false;

        constructor(id)
        {
            this.id = id;

            if ($(this.selectors.modal + '[data-modal="' + this.id + '"]').length) {
                this.init();
            }
        }

        /**
         * Modal initialization.
         */
        init()
        {
            let modal = $(this.selectors.modal + '[data-modal="' + this.id + '"]');

            modal.find(this.selectors.modalClose).on('click', (e) => {
                this.close(modal, e);
            });

            modal.find(this.selectors.modalCloseAlt).on('click', (e) => {
                this.close(modal, e);
            });

            modal.find(this.selectors.modalConfirm).on('click', () => {
                this.confirm(modal);
            });

            modal.find(this.selectors.modalAbort).on('click', () => {
                this.abort(modal);
            });
        };

        /**
         * Shows the modal.
         *
         * @returns {void}
         * @since   1.0.0
         */
        show()
        {
            $('[data-modal="' + this.id + '"]').addClass(this.classes.active).css('display', '');
            $('html').addClass(this.classes.noScroll);
        }

        /**
         * Closes the modal.
         *
         * @param   {jQuery} modal
         * @param   {Object} event
         * @returns {void}
         * @since   1.0.0
         */
        close(modal, event)
        {
            let target = $(event.target);
            let isLink = 'a' === target.prop('tagName').toLowerCase();

            if (isLink) {
                event.preventDefault();
            }

            $(modal).removeClass(this.classes.active);
            $('html').removeClass(this.classes.noScroll);

            if (isLink) {
                window.location = target.attr('href');
            }
        }

        /**
         * Closes the modal.
         *
         * @param   {jQuery} modal
         * @returns {void}
         * @since   1.0.0
         */
        confirm(modal)
        {

        }

        /**
         * Closes the modal.
         *
         * @param   {jQuery} modal
         * @returns {void}
         * @since   1.0.0
         */
        abort(modal)
        {

        }
    }

    moduleRegistrar.register(new Module('webscape-modal', Modal));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    localStorageHelper,
    FormValidator,
    objectHelper,
    undefined
) {
    class Multistep
    {
        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            stepSections: '[data-js="multistep-sections"]',
            stepSection: '[data-js="multistep-section"]',
            activeStepSection: '[data-js="multistep-section"].active',
            stepSectionWithError: '[data-js="multistep-section"].has-error',
            stepOptions: '[data-js="step-options"]',
            stepOption: '[data-js~="step-option"]',
            stepFields: '[data-js="step-fields"]',
            stepField: '[data-js~="step-field"], input, textarea',
            stepFieldWithError: '[data-js~="step-field"].has-error',
            selectBtn: '[data-js~="select-step-option"]',
            prevStep: '[data-js="prev-step"]',
            nextStep: '[data-js="next-step"]',
            goToStep: '[data-js="view-step"]',
            stepsNav: '[data-js="multistep-navigation"]',
            hasError: '.has-error',
        };

        /**
         * Element classes.
         *
         * @type {Object}
         */
        classes = {
            active: 'active',
            error: 'has-error',
        };

        elements = {
            multistep: null,
            sections: null,
        };

        /**
         * Multistep state
         *
         * @type {Object}
         */
        state = {
            index: 0,
            sections: {},
        };

        id = null;

        constructor(multistep)
        {
            this.elements.multistep = multistep;

            if ($(this.selectors.stepSection).length) {
                this.init();
            }

            $(document).on('form:contextual:init', () => {
                this.init();
            });

            $(this.elements.multistep).on('multistep:trigger:step:prev', this.prevStep.bind(this));
            $(this.elements.multistep).on('multistep:trigger:step:next', this.nextStep.bind(this));
            $(this.elements.multistep).on('multistep:trigger:step:goto', (e, index) => this.goToStep(index));
            $(this.elements.multistep).on('multistep:trigger:state:clear', this.clearState.bind(this));
            $(this.elements.multistep).on('multistep:trigger:state:get', (e, key) => this.getState(key));
            $(this.elements.multistep).on('multistep:trigger:state:set', (e, key, value) => this.setState(key, value));
        }

        init()
        {
            this.id = $(this.elements.multistep).data('id');

            if (! this.id) {
                return;
            }

            this.initState();

            this.elements.sections = $(this.elements.multistep).find(this.selectors.stepSection);

            if (! this.hasCurrentStep()) {
                let index = 0; //this.getState('index') || 0;
                this.loadStepFields(index);
                this.toggleNavigation();
                $(this.elements.sections[index]).addClass(this.classes.active);
            }

            this.elements.sections.each((index, section) => {
                $(section).attr('data-step-index', index);

                let stepFields = $(this.elements.sections[index]).find(this.selectors.stepField);
                if (stepFields.length) {
                    let inputTimeout = null;

                    stepFields.each((i, el) => {
                        $(el).on('input', () => {
                            clearTimeout(inputTimeout);
                            inputTimeout = setTimeout(() => {
                                this.storeStepFields(index);
                            }, 250);
                        });
                    });
                }
            });

            $(this.selectors.prevStep).on('click', () => {
                this.prevStep();
            });

            $(this.selectors.nextStep).on('click', () => {
                this.nextStep();
            });

            $(this.selectors.goToStep).on('click', e => {
                this.goToStep($(e.currentTarget).data('stepIndex') || $(e.currentTarget).data('stepName'));
            });
        }

        prevStep()
        {
            const currentIndex = this.getState('index');
            const newIndex = currentIndex - 1;

            $(this.elements.multistep).trigger(
                'multistep:event:step:before-prev',
                this.getStepChangedData(currentIndex, newIndex)
            );

            this.goToStep(newIndex);

            $(this.elements.multistep).trigger(
                'multistep:event:step:after-prev',
                this.getStepChangedData(currentIndex, newIndex)
            );
        }

        nextStep()
        {
            const currentIndex = this.getState('index');
            const newIndex = currentIndex + 1;

            $(this.elements.multistep).trigger(
                'multistep:event:step:before-next',
                this.getStepChangedData(currentIndex, newIndex)
            );

            this.goToStep(newIndex);

            $(this.elements.multistep).trigger(
                'multistep:event:step:after-next',
                this.getStepChangedData(currentIndex, newIndex)
            );
        }

        goToStep(index)
        {
            if (isNaN(parseInt(index))) {
                index = parseInt($(this.selectors.stepSection + '[data-step-name="' + index + '"]').data('stepIndex'));
            }

            if (! this.hasStep(index)) {
                return;
            }

            const currentIndex = this.getState('index');
            const newIndex = index;

            if (! this.validateStep(currentIndex)) {
                return;
            }

            this.scrollToTop();

            this.getStep(currentIndex).removeClass(this.classes.active);
            this.storeStepFields(currentIndex);
            this.setState('index', parseInt(newIndex));
            this.loadStepFields(newIndex);
            this.toggleNavigation();
            this.getStep(newIndex).addClass(this.classes.active);

            $(this.elements.multistep).trigger(
                'multistep:event:step:changed',
                this.getStepChangedData(currentIndex, newIndex)
            );
        }

        getStepChangedData(fromIndex, toIndex)
        {
            return {
                from: {
                    index: fromIndex,
                    name: $(this.elements.multistep).find('[data-step-index="' + fromIndex + '"]').data('stepName'),
                },
                to: {
                    index: toIndex,
                    name: $(this.elements.multistep).find('[data-step-index="' + toIndex + '"]').data('stepName'),
                },
            };
        }

        isFirstStep()
        {
            return this.getState('index') === 0;
        }

        isLastStep()
        {
            return this.getState('index') >= this.elements.sections.length - 1;
        }

        getStep(index)
        {
            return $(this.elements.sections[parseInt(index)]);
        }

        /**
         * Returns true, if there is a current (active) step, otherwise false.
         *
         * @returns {boolean}
         */
        hasCurrentStep()
        {
            return this.getCurrentStep().length;
        }

        /**
         * Retrieves the current (active) step.
         *
         * @returns {jQuery|HTMLElement|*}
         */
        getCurrentStep()
        {
            return $(this.selectors.activeStepSection);
        }

        /**
         * Returns true, if there is a step with the given index, otherwise false.
         *
         * @returns {boolean}
         */
        hasStep(index)
        {
            return null !== this.elements.sections
                && this.elements.sections.hasOwnProperty(parseInt(index));
        }

        getState(key)
        {
            return objectHelper.get(this.state, key);
        }

        setState(key, value)
        {
            objectHelper.set(this.state, key, value);
            localStorageHelper.set(this.id, this.state);
            //this.setHistoryState(key, value);
        }

        clearState()
        {
            this.state = {
                index: 0,
                sections: {},
            };

            localStorageHelper.set(this.id, this.state);
        }

        initState()
        {
            this.state = localStorageHelper.get(this.id) || this.state;

            let currentUrl = new URL(window.location);

            currentUrl.searchParams.forEach((value, key) => {
                this.state[key] = value;
            });

            this.setState('index', 0);
        }

        setHistoryState(key, value)
        {
            let currentUrl = new URL(window.location);

            if (null === value || typeof value === 'string' && '' === value.trim()) {
                currentUrl.searchParams.delete(key);
            } else {
                currentUrl.searchParams.set(key, value);
            }

            window.history.replaceState(null, '', currentUrl);
        }

        validateStep(index)
        {
            let stepValidateEvent = $.Event('multistep:event:step:validate');
            stepValidateEvent.result = true;

            $(this.elements.multistep).trigger(stepValidateEvent, {
                step: index,
            });

            if (typeof stepValidateEvent.result !== 'undefined' && ! stepValidateEvent.result) {
                $(this.elements.multistep).trigger('multistep:event:step:validated', {
                    step: index,
                    passed: false,
                });

                return false;
            }

            if ($(this.elements.sections[index]).find(this.selectors.stepField)) {
                this.addValidator(index, 'formValidator', new FormValidator());
            }

            let passed = true;

            if (! this.elements.sections[index].hasOwnProperty('validators')) {
                return passed;
            }

            Object.keys(this.elements.sections[index].validators).forEach(name => {
                if ('formValidator' === name) {
                    let rules = {};
                    let data = {};

                    $(this.elements.sections[index]).find(this.selectors.stepField).each((i, field) => {
                        if (! $(field).data('validate')) {
                            return;
                        }

                        rules[$(field).prop('id')] = $(field).data('validate').split(',');
                        data[$(field).prop('id')] = $(field).val();
                    });

                    this.elements.sections[index].validators[name].init(data, rules);
                }

                if (! this.elements.sections[index].validators[name].validate()) {
                    passed = false;
                }
            });

            $(this.elements.multistep).trigger('multistep:event:step:validated', {
                step: index,
                passed: passed,
            });

            return passed;
        }

        addValidator(index, name, validator)
        {
            index = parseInt(index);

            if (! this.elements.sections[index].hasOwnProperty('validators')) {
                this.elements.sections[parseInt(index)].validators = {};
            }

            this.elements.sections[parseInt(index)].validators[name] = validator;
        }

        storeStepFields(index)
        {
            $(this.elements.sections[index]).find(this.selectors.stepField).each((i, field) => {
                let value;

                if ($(field).attr('type') === 'radio' || $(field).attr('type') === 'checkbox') {
                    value = $(field).prop('checked');
                } else {
                    value = $(field).val();
                }

                this.setState('sections.' + index + '.fields.' + $(field).attr('id'), value);
            });
        }

        loadStepFields(index)
        {
            $(this.elements.sections[index]).find(this.selectors.stepField).each((i, field) => {
                let value = this.getState('sections.' + index + '.fields.' + $(field).attr('id'));

                if (typeof value === 'object') {
                    return;
                }

                if ($(field).attr('type') === 'radio' || $(field).attr('type') === 'checkbox') {
                    $(field).prop('checked', value);
                    return;
                }

                $(field).val(value);
            });
        }

        toggleNavigation()
        {
            if (this.isFirstStep()) {
                $(this.elements.multistep).addClass('is-first-step');
                $(this.elements.multistep).removeClass('is-last-step');
            } else if (this.isLastStep()) {
                $(this.elements.multistep).addClass('is-last-step');
                $(this.elements.multistep).removeClass('is-first-step');
            } else {
                $(this.elements.multistep).removeClass('is-first-step');
                $(this.elements.multistep).removeClass('is-last-step');
            }
        }

        scrollToTop()
        {
            if ($(document).scrollTop() > 0) {
                $('html, body').animate({ scrollTop: 0 }, 'slow');
            }
        }
    }

    moduleRegistrar.register(new Module('webscape-multistep', Multistep, '[data-js="multistep"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-local-storage').getInstance(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-form-validator').getClass(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-object-helper').getInstance()
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    PartialsAjaxController,
    undefined
) {
    class PostListAjaxController extends PartialsAjaxController
    {
        /**
         * Post types the AJAX list is for.
         *
         * @type {Array}
         */
        postTypes = ['post'];

        /**
         * AJAX data.
         *
         * @type {Object|Array|string}
         */
        data = {
            action: 'webscape_post_list',
            fields: {},
            listing_ajax: false,
        };

        /**
         * Element selectors.
         *
         * @type {Object}
         */
        selectors = {
            listingToolbar: '[data-js~="listing_toolbar"]',
            listingAction: '[data-js~="listing_action"]',
            listingActionInput: '[data-js~="listing_action_input"]',
            itemsListing: '[data-js~="items_listing"]',
            listingSortingOrder: '[data-js~="listing_sorting_order"]',
            listingPagination: '[data-js="listing_pagination"]',
        };

        /**
         * Input timeouts for action fields.
         *
         * @type {Object}
         */
        fieldInputTimeouts = {};

        constructor(el)
        {
            super();

            this.el = el;
            const itemsListing = $(this.el).find(this.selectors.itemsListing);

            if (itemsListing.data('action')) {
                this.data.action = itemsListing.data('action');
            } else {
                this.data.action = 'webscape_' + this.postTypes.join('_') + '_list';
            }

            this.init();
        }

        init()
        {
            if (! this.verifyPostTypes()) {
                return;
            }

            // Retrieve the current field values.
            this.applyFieldValues();
            this.setupEvents();

            $(document).on('webscapa_partials_ajax:success', (e) => {
                this.setupEvents();
            });
        }

        setupEvents()
        {
            for (const action of this.getListingActions()) {
                const fieldKey = $(action).attr('name');
                const actionDelayed = $(action).data('listingActionDelayed');
                const inputType = $(action).tagName;

                $(action).off().on('SELECT' === inputType ? 'change' : 'input', (e) => {
                    this.applyFieldValues();

                    if ('listing_search' === fieldKey) {
                        this.data.fields['listing_pagination'] = 1;
                        this.data.paged = 1;
                    }

                    if (actionDelayed) {
                        if (this.fieldInputTimeouts[fieldKey]) {
                            clearTimeout(this.fieldInputTimeouts[fieldKey]);
                            this.fieldInputTimeouts[fieldKey] = null;
                        }

                        this.data.fields[fieldKey] = $(e.currentTarget).val();

                        this.fieldInputTimeouts[fieldKey] = setTimeout(() => {
                            this.execute();
                        }, 400);
                    } else {
                        this.data.fields[fieldKey] = $(e.currentTarget).val();
                        this.execute();
                    }
                });
            }

            $(this.el).find(this.selectors.listingSortingOrder).off().on('click', (e) => {
                let order = $(e.currentTarget).data('order');

                if ('ASC' === order) {
                    $('[data-js~="listing_sorting_order_desc"]').removeClass('hidden');
                    $(e.currentTarget).addClass('hidden');
                } else {
                    $('[data-js~="listing_sorting_order_asc"]').removeClass('hidden');
                    $(e.currentTarget).addClass('hidden');
                }

                $('#listing_order').val(order).trigger('input');
            });

            $(this.el).find(this.selectors.listingPagination).find('a').off().on('click', (e) => {
                if (! this.data.listing_ajax) {
                    return;
                }

                let currentPage = $(e.currentTarget).data('page');
                this.data.paged = currentPage;

                let baseUrl = $(this.selectors.itemsListing).data('url');
                let newUrl = baseUrl;

                if (currentPage > 1) {
                    newUrl = baseUrl.replace(/\/$/, '') + '/page/' + currentPage + '/';
                }

                history.pushState(null, '', newUrl);

                $('#listing_pagination').val(currentPage).trigger('input');
            });
        }

        /**
         * Sets the post types.
         *
         * @param {Array} postTypes
         */
        setPostTypes(postTypes)
        {
            this.postTypes = postTypes;

            if ($(this.el).find(this.selectors.itemsListing).data('action')) {
                this.data.action = $(this.el).find(this.selectors.itemsListing).data('action');
            } else {
                this.data.action = 'webscape_' + this.postTypes.join('_') + '_list';
            }
        }

        /**
         * Verifies that the listing is for the right post type.
         *
         * @return {boolean}
         * @since  1.0.0
         */
        verifyPostTypes()
        {
            let postTypes = $(this.selectors.itemsListing).data('postTypes');

            if (! postTypes) {
                return false;
            }

            postTypes = postTypes.split(',');

            for (const postType of postTypes) {
                if (this.postTypes.includes(postType)) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Retrieves the listing actions config.
         *
         * @return {jQuery|{}}
         * @since  1.0.0
         */
        getListingActions()
        {
            return $(this.el).find(this.selectors.listingActionInput);
        }

        /**
         * Retrieves the field values for all actions.
         */
        applyFieldValues()
        {
            for (const action of this.getListingActions()) {
                const fieldKey = $(action).attr('name');
                this.data.fields[fieldKey] = $(action).val();
            }

            this.data.listing_ajax = true;
        }

        /**
         * @inheritDoc
         */
        execute()
        {
            if (! this.verifyPostTypes()) {
                return;
            }

            return super.execute();
        }
    }

    moduleRegistrar.register(new Module('webscape-post-list-ajax', PostListAjaxController, '[data-js~="site-main"]'));
})(
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-partials-ajax').getClass()
);

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
	window : {},
	/**
	 * @typedef { import("./types/global").LazySizesConfigPartial } LazySizesConfigPartial
	 */
	function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
		'use strict';
		/*jshint eqnull:true */

		var lazysizes,
			/**
			 * @type { LazySizesConfigPartial }
			 */
			lazySizesCfg;

		(function(){
			var prop;

			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				fastLoadedClass: 'ls-is-cached',
				iframeLoadMode: 0,
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2,
				loadHidden: true,
				ricTimeout: 0,
				throttleDelay: 125,
			};

			lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

			for(prop in lazySizesDefaults){
				if(!(prop in lazySizesCfg)){
					lazySizesCfg[prop] = lazySizesDefaults[prop];
				}
			}
		})();

		if (!document || !document.getElementsByClassName) {
			return {
				init: function () {},
				/**
				 * @type { LazySizesConfigPartial }
				 */
				cfg: lazySizesCfg,
				/**
				 * @type { true }
				 */
				noSupport: true,
			};
		}

		var docElem = document.documentElement;

		var supportPicture = window.HTMLPictureElement;

		var _addEventListener = 'addEventListener';

		var _getAttribute = 'getAttribute';

		/**
		 * Update to bind to window because 'this' becomes null during SSR
		 * builds.
		 */
		var addEventListener = window[_addEventListener].bind(window);

		var setTimeout = window.setTimeout;

		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

		var requestIdleCallback = window.requestIdleCallback;

		var regPicture = /^picture$/i;

		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

		var regClassCache = {};

		var forEach = Array.prototype.forEach;

		/**
		 * @param ele {Element}
		 * @param cls {string}
		 */
		var hasClass = function(ele, cls) {
			if(!regClassCache[cls]){
				regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};

		/**
		 * @param ele {Element}
		 * @param cls {string}
		 */
		var addClass = function(ele, cls) {
			if (!hasClass(ele, cls)){
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};

		/**
		 * @param ele {Element}
		 * @param cls {string}
		 */
		var removeClass = function(ele, cls) {
			var reg;
			if ((reg = hasClass(ele,cls))) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};

		var addRemoveLoadEvents = function(dom, fn, add){
			var action = add ? _addEventListener : 'removeEventListener';
			if(add){
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function(evt){
				dom[action](evt, fn);
			});
		};

		/**
		 * @param elem { Element }
		 * @param name { string }
		 * @param detail { any }
		 * @param noBubbles { boolean }
		 * @param noCancelable { boolean }
		 * @returns { CustomEvent }
		 */
		var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
			var event = document.createEvent('Event');

			if(!detail){
				detail = {};
			}

			detail.instance = lazysizes;

			event.initEvent(name, !noBubbles, !noCancelable);

			event.detail = detail;

			elem.dispatchEvent(event);
			return event;
		};

		var updatePolyfill = function (el, full){
			var polyfill;
			if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
				if(full && full.src && !el[_getAttribute]('srcset')){
					el.setAttribute('srcset', full.src);
				}
				polyfill({reevaluate: true, elements: [el]});
			} else if(full && full.src){
				el.src = full.src;
			}
		};

		var getCSS = function (elem, style){
			return (getComputedStyle(elem, null) || {})[style];
		};

		/**
		 *
		 * @param elem { Element }
		 * @param parent { Element }
		 * @param [width] {number}
		 * @returns {number}
		 */
		var getWidth = function(elem, parent, width){
			width = width || elem.offsetWidth;

			while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
				width =  parent.offsetWidth;
				parent = parent.parentNode;
			}

			return width;
		};

		var rAF = (function(){
			var running, waiting;
			var firstFns = [];
			var secondFns = [];
			var fns = firstFns;

			var run = function(){
				var runFns = fns;

				fns = firstFns.length ? secondFns : firstFns;

				running = true;
				waiting = false;

				while(runFns.length){
					runFns.shift()();
				}

				running = false;
			};

			var rafBatch = function(fn, queue){
				if(running && !queue){
					fn.apply(this, arguments);
				} else {
					fns.push(fn);

					if(!waiting){
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};

			rafBatch._lsFlush = run;

			return rafBatch;
		})();

		var rAFIt = function(fn, simple){
			return simple ?
				function() {
					rAF(fn);
				} :
				function(){
					var that = this;
					var args = arguments;
					rAF(function(){
						fn.apply(that, args);
					});
				}
				;
		};

		var throttle = function(fn){
			var running;
			var lastTime = 0;
			var gDelay = lazySizesCfg.throttleDelay;
			var rICTimeout = lazySizesCfg.ricTimeout;
			var run = function(){
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback && rICTimeout > 49 ?
				function(){
					requestIdleCallback(run, {timeout: rICTimeout});

					if(rICTimeout !== lazySizesCfg.ricTimeout){
						rICTimeout = lazySizesCfg.ricTimeout;
					}
				} :
				rAFIt(function(){
					setTimeout(run);
				}, true)
			;

			return function(isPriority){
				var delay;

				if((isPriority = isPriority === true)){
					rICTimeout = 33;
				}

				if(running){
					return;
				}

				running =  true;

				delay = gDelay - (Date.now() - lastTime);

				if(delay < 0){
					delay = 0;
				}

				if(isPriority || delay < 9){
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};

		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function(){
				timeout = null;
				func();
			};
			var later = function() {
				var last = Date.now() - timestamp;

				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};

			return function() {
				timestamp = Date.now();

				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};

		var loader = (function(){
			var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;

			var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

			var shrinkExpand = 0;
			var currentExpand = 0;

			var isLoading = 0;
			var lowRuns = -1;

			var resetPreloading = function(e){
				isLoading--;
				if(!e || isLoading < 0 || !e.target){
					isLoading = 0;
				}
			};

			var isVisible = function (elem) {
				if (isBodyHidden == null) {
					isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
				}

				return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
			};

			var isNestedVisible = function(elem, elemExpand){
				var outerRect;
				var parent = elem;
				var visible = isVisible(elem);

				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;

				while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
					visible = ((getCSS(parent, 'opacity') || 1) > 0);

					if(visible && getCSS(parent, 'overflow') != 'visible'){
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left &&
							eLleft < outerRect.right &&
							eLbottom > outerRect.top - 1 &&
							eLtop < outerRect.bottom + 1
						;
					}
				}

				return visible;
			};

			var checkElements = function() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
					beforeExpandVal, defaultExpand, preloadExpand, hFac;
				var lazyloadElems = lazysizes.elements;

				if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

					i = 0;

					lowRuns++;

					for(; i < eLlen; i++){

						if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

						if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

						if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
							elemExpand = currentExpand;
						}

						if (!defaultExpand) {
							defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
								docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
								lazySizesCfg.expand;

							lazysizes._defEx = defaultExpand;

							preloadExpand = defaultExpand * lazySizesCfg.expFactor;
							hFac = lazySizesCfg.hFac;
							isBodyHidden = null;

							if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
								currentExpand = preloadExpand;
								lowRuns = 0;
							} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
								currentExpand = defaultExpand;
							} else {
								currentExpand = shrinkExpand;
							}
						}

						if(beforeExpandVal !== elemExpand){
							eLvW = innerWidth + (elemExpand * hFac);
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}

						rect = lazyloadElems[i].getBoundingClientRect();

						if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
							(eLtop = rect.top) <= elvH &&
							(eLright = rect.right) >= elemNegativeExpand * hFac &&
							(eLleft = rect.left) <= eLvW &&
							(eLbottom || eLright || eLleft || eLtop) &&
							(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
							((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if(isLoading > 9){break;}
						} else if(!loadedSomething && isCompleted && !autoLoadElem &&
							isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
							(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
							(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}

					if(autoLoadElem && !loadedSomething){
						unveilElement(autoLoadElem);
					}
				}
			};

			var throttledCheckElements = throttle(checkElements);

			var switchLoadingClass = function(e){
				var elem = e.target;

				if (elem._lazyCache) {
					delete elem._lazyCache;
					return;
				}

				resetPreloading(e);
				addClass(elem, lazySizesCfg.loadedClass);
				removeClass(elem, lazySizesCfg.loadingClass);
				addRemoveLoadEvents(elem, rafSwitchLoadingClass);
				triggerEvent(elem, 'lazyloaded');
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function(e){
				rafedSwitchLoadingClass({target: e.target});
			};

			var changeIframeSrc = function(elem, src){
				var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

				// loadMode can be also a string!
				if (loadMode == 0) {
					elem.contentWindow.location.replace(src);
				} else if (loadMode == 1) {
					elem.src = src;
				}
			};

			var handleSources = function(source){
				var customMedia;

				var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

				if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
					source.setAttribute('media', customMedia);
				}

				if(sourceSrcset){
					source.setAttribute('srcset', sourceSrcset);
				}
			};

			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
				var src, srcset, parent, isPicture, event, firesLoad;

				if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

					if(sizes){
						if(isAuto){
							addClass(elem, lazySizesCfg.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}

					srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
					src = elem[_getAttribute](lazySizesCfg.srcAttr);

					if(isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}

					firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

					event = {target: elem};

					addClass(elem, lazySizesCfg.loadingClass);

					if(firesLoad){
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}

					if(isPicture){
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}

					if(srcset){
						elem.setAttribute('srcset', srcset);
					} else if(src && !isPicture){
						if(regIframe.test(elem.nodeName)){
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}

					if(isImg && (srcset || isPicture)){
						updatePolyfill(elem, {src: src});
					}
				}

				if(elem._lazyRace){
					delete elem._lazyRace;
				}
				removeClass(elem, lazySizesCfg.lazyClass);

				rAF(function(){
					// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
					var isLoaded = elem.complete && elem.naturalWidth > 1;

					if( !firesLoad || isLoaded){
						if (isLoaded) {
							addClass(elem, lazySizesCfg.fastLoadedClass);
						}
						switchLoadingClass(event);
						elem._lazyCache = true;
						setTimeout(function(){
							if ('_lazyCache' in elem) {
								delete elem._lazyCache;
							}
						}, 9);
					}
					if (elem.loading == 'lazy') {
						isLoading--;
					}
				}, true);
			});

			/**
			 *
			 * @param elem { Element }
			 */
			var unveilElement = function (elem){
				if (elem._lazyRace) {return;}
				var detail;

				var isImg = regImg.test(elem.nodeName);

				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';

				if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

				detail = triggerEvent(elem, 'lazyunveilread').detail;

				if(isAuto){
					autoSizer.updateElem(elem, true, elem.offsetWidth);
				}

				elem._lazyRace = true;
				isLoading++;

				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};

			var afterScroll = debounce(function(){
				lazySizesCfg.loadMode = 3;
				throttledCheckElements();
			});

			var altLoadmodeScrollListner = function(){
				if(lazySizesCfg.loadMode == 3){
					lazySizesCfg.loadMode = 2;
				}
				afterScroll();
			};

			var onload = function(){
				if(isCompleted){return;}
				if(Date.now() - started < 999){
					setTimeout(onload, 999);
					return;
				}


				isCompleted = true;

				lazySizesCfg.loadMode = 3;

				throttledCheckElements();

				addEventListener('scroll', altLoadmodeScrollListner, true);
			};

			return {
				_: function(){
					started = Date.now();

					lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

					addEventListener('scroll', throttledCheckElements, true);

					addEventListener('resize', throttledCheckElements, true);

					addEventListener('pageshow', function (e) {
						if (e.persisted) {
							var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

							if (loadingElements.length && loadingElements.forEach) {
								requestAnimationFrame(function () {
									loadingElements.forEach( function (img) {
										if (img.complete) {
											unveilElement(img);
										}
									});
								});
							}
						}
					});

					if(window.MutationObserver){
						new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}

					addEventListener('hashchange', throttledCheckElements, true);

					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
						document[_addEventListener](name, throttledCheckElements, true);
					});

					if((/d$|^c/.test(document.readyState))){
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}

					if(lazysizes.elements.length){
						checkElements();
						rAF._lsFlush();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement,
				_aLSL: altLoadmodeScrollListner,
			};
		})();


		var autoSizer = (function(){
			var autosizesElems;

			var sizeElement = rAFIt(function(elem, parent, event, width){
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';

				elem.setAttribute('sizes', width);

				if(regPicture.test(parent.nodeName || '')){
					sources = parent.getElementsByTagName('source');
					for(i = 0, len = sources.length; i < len; i++){
						sources[i].setAttribute('sizes', width);
					}
				}

				if(!event.detail.dataAttr){
					updatePolyfill(elem, event.detail);
				}
			});
			/**
			 *
			 * @param elem {Element}
			 * @param dataAttr
			 * @param [width] { number }
			 */
			var getSizeElement = function (elem, dataAttr, width){
				var event;
				var parent = elem.parentNode;

				if(parent){
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

					if(!event.defaultPrevented){
						width = event.detail.width;

						if(width && width !== elem._lazysizesWidth){
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};

			var updateElementsSizes = function(){
				var i;
				var len = autosizesElems.length;
				if(len){
					i = 0;

					for(; i < len; i++){
						getSizeElement(autosizesElems[i]);
					}
				}
			};

			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

			return {
				_: function(){
					autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		})();

		var init = function(){
			if(!init.i && document.getElementsByClassName){
				init.i = true;
				autoSizer._();
				loader._();
			}
		};

		setTimeout(function(){
			if(lazySizesCfg.init){
				init();
			}
		});

		lazysizes = {
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF,
		};

		return lazysizes;
	}
));

